import {Title, type TitleOrder} from '@mantine/core';
import {MdArrowBackIos, MdArrowForwardIos} from 'react-icons/md';
import {cn} from '../../../../../lib/classname';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {useIsAppWebView} from '../../../../../shared/hooks/useIsAppWebView';

type RightLinkProps = {
  href: string;
  title?: string;
  icon?: React.ReactNode;
};

type Props = {
  componentId: string;
  title: string;
  titleOrder?: TitleOrder;
  href?: string;
  description?: string;
  hasBack?: boolean;
  rightLink?: RightLinkProps;
  rightElement?: React.ReactNode;
};

export const SectionHeader: React.FC<Props> = ({
  componentId,
  title,
  titleOrder = 2,
  href,
  description,
  hasBack,
  rightLink,
  rightElement,
}) => {
  const isWebView = useIsAppWebView();
  const hrefLink = isWebView ? null : href;
  const fixedHasBack = isWebView ? false : hasBack;
  return (
    <div
      className={cn(
        'mx-auto items-center w-full',
        'pc:bg-white pc:p-16 pc:rounded-12 pc:shadow-card pc:my-0 pc:max-w-[1200px]',
        {
          'bg-white p-16 rounded-12 shadow-card': hasBack,
        },
      )}
    >
      <div className="flex justify-between items-center">
        {hrefLink ? (
          <CommonLink
            href={hrefLink}
            className="hover:opacity-70"
            data-gtm-click={`${componentId}-header`}
          >
            <TitleText
              title={title}
              titleOrder={titleOrder}
              hasArrow
              hasBack={fixedHasBack}
            />
          </CommonLink>
        ) : (
          <TitleText
            title={title}
            titleOrder={titleOrder}
            hasBack={fixedHasBack}
          />
        )}
        {rightLink && (
          <CommonLink
            href={rightLink.href}
            className="flex items-center hover:opacity-70 text-sm text-primary gap-4"
          >
            {rightLink.icon && <span>{rightLink.icon}</span>}
            {rightLink.title && <span>{rightLink.title}</span>}
          </CommonLink>
        )}
        {rightElement && <>{rightElement}</>}
      </div>
      {description && (
        <div className="text-base hidden pc:block">{description}</div>
      )}
    </div>
  );
};

const TitleText: React.FC<{
  title: string;
  titleOrder: TitleOrder;
  hasArrow?: boolean;
  hasBack?: boolean;
}> = ({title, titleOrder, hasArrow, hasBack}) => (
  <div className="flex flex-row justify-between items-center">
    <Title
      order={titleOrder}
      className="flex items-center gap-4 text-lg pc:text-xl text-black font-bold"
    >
      {hasBack && <MdArrowBackIos size={20} />}
      {title}
      {hasArrow && !hasBack && <MdArrowForwardIos size={20} />}
    </Title>
  </div>
);
